document.addEventListener("DOMContentLoaded", function () {
  // Seleciona todos os elementos de countdown
  var countdownElements = document.querySelectorAll(".bluety-countdown-timer");

  function updateCountdown(countdownElement) {
    var promoDate = countdownElement.dataset.limitDate;
    var endDate = new Date(promoDate + "T23:59:59");

    function update() {
      var now = new Date();
      var timeDiff = endDate - now;

      if (timeDiff <= 0) {
        countdownElement.innerHTML = "Promo over";
        return;
      }

      var days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      countdownElement.innerHTML =
        days +
        "<sup>j</sup> " +
        hours +
        "<sup>h</sup> " +
        minutes +
        "<sup>m</sup> " +
        seconds +
        "<sup>s</sup>";
    }

    update(); // Inicializa o contador
    setInterval(update, 1000); // Atualiza o timer a cada segundo
  }

  countdownElements.forEach(function (countdownElement) {
    updateCountdown(countdownElement);
  });
});
